import { gql } from '@apollo/client';

export const fetchAuditNotesForEntity = gql`
  query fetchAuditNotesForEntity($searchParams: CommerceNoteSearchParams, $searchOptions: ConnectionSearchOptions) {
    auditNotes(searchParams: $searchParams, searchOptions: $searchOptions) {
      totalCount
      nodes {
        id
        body
        author
        created
        contactKey
        metadata {
          fieldName
          fieldValue
        }
        creditNoteStatus
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
